module.exports = __webpack_public_path__ + "assets/img/ieo.1618572b.png";